import { Component, OnInit, Output, EventEmitter, ViewChild, Input, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormService } from '../../../form.service';
import { ActivatedRoute } from '@angular/router';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { HttpError } from '../../../errors';

@Component({
    selector: 'app-assignment-criteria',
    templateUrl: './assignment-criteria.component.html',
    styleUrls: ['./assignment-criteria.component.scss']
})
export class AssignmentCriteriaComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<boolean>();

    @ViewChild('assignmentForm') assignmentForm: NgForm;

    private formCode;

    @Input('assignmentCriteria') assignmentCriteria;
    @Output('change') change = new EventEmitter();

    constructor(private formService: FormService, private route: ActivatedRoute, private snackbar: SemsoSnackbarService) { }

    ngOnInit() {
        this.assignmentForm.statusChanges
        .takeUntil(this.destroy$).subscribe(() => {
            this.change.next();
        });

        this.route.params
        .takeUntil(this.destroy$)
        .subscribe(params => {
            this.formCode = params['formCode'];
        });
    }

    clear() {
        this.assignmentCriteria.geselecteerdeWaarde = 1;
        this.updateGrade(this.assignmentCriteria.geselecteerdeWaarde);
    }

    valid() {
        if (this.assignmentCriteria.geselecteerdeWaarde === 2) {
            return true;
        }

        if (this.assignmentCriteria.opmerkingen && this.assignmentCriteria.opmerkingen.length > 0) {
            return true;
        }

        return false;
    }

    updateGrade(event) {
        this.formService.postFormById(this.formCode, {
            opdrachtformuliervraagId: this.assignmentCriteria.id,
            waarde: this.assignmentCriteria.geselecteerdeWaarde,
            omschrijving: this.assignmentCriteria.opmerkingen
        })
        .takeUntil(this.destroy$)
        .subscribe(() => {}, e => {
            throw this.error(`Fout bij het opslaan van het cijfer voor formulier: ${this.formCode}`);
        });
    }

    ngOnDestroy() {
        this.destroy$.next(false);
    }

    private error(message) {
        this.snackbar.error(message);
        return new HttpError(message);
    }
}



// WEBPACK FOOTER //
// ./src/app/exam-preparation/determination-assignment-pvb/assignment-criteria/assignment-criteria.component.ts